var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/more-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-square"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99967 15.1667H5.99967C2.37967 15.1667 0.833008 13.62 0.833008 10V6.00001C0.833008 2.38001 2.37967 0.833344 5.99967 0.833344H9.99967C13.6197 0.833344 15.1663 2.38001 15.1663 6.00001V10C15.1663 13.62 13.6197 15.1667 9.99967 15.1667ZM5.99967 1.83334C2.92634 1.83334 1.83301 2.92668 1.83301 6.00001V10C1.83301 13.0733 2.92634 14.1667 5.99967 14.1667H9.99967C13.073 14.1667 14.1663 13.0733 14.1663 10V6.00001C14.1663 2.92668 13.073 1.83334 9.99967 1.83334H5.99967Z",
    fill: "#FDB022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.99967 8.66668C7.62634 8.66668 7.33301 8.36668 7.33301 8.00001C7.33301 7.63334 7.63301 7.33334 7.99967 7.33334C8.36634 7.33334 8.66634 7.63334 8.66634 8.00001C8.66634 8.36668 8.37301 8.66668 7.99967 8.66668Z",
    fill: "#FDB022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6667 8.66668C10.2933 8.66668 10 8.36668 10 8.00001C10 7.63334 10.3 7.33334 10.6667 7.33334C11.0333 7.33334 11.3333 7.63334 11.3333 8.00001C11.3333 8.36668 11.04 8.66668 10.6667 8.66668Z",
    fill: "#FDB022"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.33366 8.66668C4.96033 8.66668 4.66699 8.36668 4.66699 8.00001C4.66699 7.63334 4.96699 7.33334 5.33366 7.33334C5.70033 7.33334 6.00033 7.63334 6.00033 8.00001C6.00033 8.36668 5.70699 8.66668 5.33366 8.66668Z",
    fill: "#FDB022"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a5e9825180966c51d00db7ae76602cdc.svg";
export { ForwardRef as ReactComponent };